import PropTypes from 'prop-types';
import React from 'react';

const CalciteInput = ({id, className, value, placeholder, icon, scale, status, onChange, onInput, testId}) => {
  const calciteInputRef = React.useRef(null);
  React.useEffect(() => {
    const element = calciteInputRef.current;
    if (onChange && element) {
      element.addEventListener('calciteInputChange', onChange);
    }
    if (onInput && element) {
      element.addEventListener('calciteInputInput', onInput);
    }
    return () => {
      if (onChange && element) {
        element.removeEventListener('calciteInputChange', onChange);
      }
      if (onInput && element) {
        element.removeEventListener('calciteInputInput', onInput);
      }
    };
  }, []);
  return (
    <calcite-input
      data-testid={testId}
      id={id || undefined}
      class={className || undefined}
      value={value || undefined}
      placeholder={placeholder || undefined}
      icon={icon || undefined}
      scale={scale || 'm'}
      status={status || 'idle'}
      onChange={onChange || undefined}
      onInput={onInput || undefined}
      ref={calciteInputRef}
    ></calcite-input>
  );
};

CalciteInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  scale: PropTypes.oneOf(['s', 'm', 'l']),
  status: PropTypes.oneOf(['idle', 'invalid', 'valid']),
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  testId: PropTypes.string,
};

export default CalciteInput;
